// extracted by mini-css-extract-plugin
module.exports = {"whiteInput":"HowWillBePaidSection_whiteInput__32Y8e","howPropertyWillBePaidSection":"HowWillBePaidSection_howPropertyWillBePaidSection__dLGbm"};